export enum UserRole {
  BusinessPartnerAdministrator = 'bp_admin',
  ItAdministrator = 'it_admin',
  /** PM role; granted by `topcon.customer_service.support` and `topcon.gnss.network_administrator`. */
  SupportAllBusinessPartners = 'all_bps',
  /** PAP role; granted by `topcon.customer_service.support`. */
  SupportAllIdentities = 'all_identities',
  ServiceCustomerAdministrator = 'sa_customer_admin',
  ServiceProviderAdministrator = 'sa_sp_admin',
  UserAdministrator = 'user_admin',
}
